<script lang="ts">
import { defineComponent, h, toRefs, unref } from 'vue';

import { Touch } from '@components/directives/touch';
import { classNames } from '@components/utils';

import { makeGroupProps, makeReadonlyProps, makeThemeProps, provideTheme, useGroup, useRender } from '../../composable';

import { CdsStepsGroupSymbol, useProvideSteps } from './context';

import type { PropType } from 'vue';

export const componentName = 'CdsSteps';
export default defineComponent({
  name: componentName,
  directives: { Touch },
  props: {
    /**
     * Вертикальное отображение
     */
    vertical: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    /**
     * Возможность перемещения по шагам кликом
     */
    interactive: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    ...makeReadonlyProps(),
    ...makeGroupProps(),
    ...makeThemeProps()
  },
  emits: {
    /**
     * Событие изменения v-model
     * @type { boolean }
     */
    'update:modelValue': (value: unknown) => true
  },
  setup(props, { slots }) {
    const { themeClasses } = provideTheme(props);
    useGroup(props, CdsStepsGroupSymbol);

    const { readonly, interactive, vertical } = toRefs(props);

    useProvideSteps({
      interactive,
      readonly,
      vertical
    });

    useRender(() => {
      return h(
        'ul',
        {
          class: classNames('cds-steps', unref(themeClasses), {
            'cds-steps--vertical': props.vertical,
            'cds-steps--interactive': props.interactive
          })
        },
        [slots.default?.()]
      );
    });

    return {};
  }
});
</script>

<style lang="scss">
@import './CdsSteps';
</style>
